import React from 'react';
import { Table, ScrollArea, useMantineTheme, Group } from '@mantine/core';
import { IconPencil, IconTrash } from '@tabler/icons-react';

import THSort from "../../components/general/THSort";
import THPlain from "../../components/general/THPlain";
import ActionIconComponent from "../../components/general/ActionIconComponent";

const StockCategorySubTable = ({ stateData, stateSortList, stateSortSelected, fnSort, stateDataOffset, fnSelectedDataEdit, fnSelectedDataDelete, fnSelectedDataView }) => {

    const theme = useMantineTheme();

    const TD = ({ children, stateNoWrap = true }) => {
        return (
            <td
                style={{
                    whiteSpace: stateNoWrap ? 'nowrap' : 'normal',
                    color: theme.colorScheme === 'light' ? theme.colors.gray[7] : theme.colors.gray[6],
                }}
            >
                {children}
            </td>
        )
    }

    return (
        <ScrollArea>
            <Table
                highlightOnHover
                verticalSpacing="sm"

                sx={() => ({
                    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[8],

                    '& thead.tableHeadSticky': {
                        position: 'sticky',
                        top: '0px',
                    },

                    '& thead tr th': {
                        paddingTop: theme.spacing.sm,
                        paddingBottom: theme.spacing.sm,
                    },
                    '& thead tr th.THSort:hover': {
                        backgroundColor: `${theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[5]} !important`
                    },
                    '& thead tr th:not(:nth-last-of-type(1)) .wrapperContentTH': {
                        borderRight: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[4] : theme.colors.dark[4]}`,
                    },
                })}
            >
                <thead>
                    <tr>
                        <THPlain stateCaption='No' />

                        <THSort
                            stateSortInUse={stateSortList.stockCategorySubName}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THSort
                            stateSortInUse={stateSortList.stockCategoryName}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THSort
                            stateSortInUse={stateSortList.stockCategorySubStockMin}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THSort
                            stateSortInUse={stateSortList.stockCategorySubStockActual}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THSort
                            stateSortInUse={stateSortList.stockCategorySubIsActive}
                            stateSortSelected={stateSortSelected}
                            fnSort={fnSort}
                        />

                        <THPlain stateCaption='' />
                    </tr>
                </thead>

                <tbody>
                    {Object.keys(stateData).map((key, index) => {
                        return (
                            <tr
                                key={key}
                                style={{
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    fnSelectedDataView(stateData[key]);
                                }}
                            >
                                <TD>{Number(stateDataOffset) + Number(index) + 1}</TD>

                                <TD>{stateData[key].stock_category_sub_name}</TD>

                                <TD>{stateData[key].stock_category_name}</TD>

                                <TD>{stateData[key].stock_category_sub_stock_min}</TD>

                                <TD>{stateData[key].stock_actual}</TD>

                                <TD>{stateData[key].stock_category_sub_is_active === '1' ? 'Aktif' : 'Non Aktif'}</TD>

                                <TD>
                                    <Group spacing='xs' noWrap>
                                        <ActionIconComponent
                                            stateVariant='subtle'
                                            stateRadius='xl'
                                            stateTitle='Edit'
                                            stateSize='lg'

                                            StateIcon={IconPencil}
                                            stateIconSize='1.1rem'
                                            stateIconStrokeWidth={1}

                                            stateSXActionIcon={{
                                                '&:hover': {
                                                    backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[4]
                                                },
                                            }}

                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}

                                            fnOnClick={(e) => {
                                                e.stopPropagation();
                                                fnSelectedDataEdit(stateData[key]);
                                            }}
                                        />

                                        <ActionIconComponent
                                            stateVariant='subtle'
                                            stateRadius='xl'
                                            stateTitle='Delete'
                                            stateSize='lg'

                                            StateIcon={IconTrash}
                                            stateIconSize='1.1rem'
                                            stateIconStrokeWidth={1}

                                            stateSXActionIcon={{
                                                '&:hover': {
                                                    backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[3] : theme.colors.dark[4]
                                                },
                                            }}

                                            stateIconStyle={{
                                                color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                            }}

                                            fnOnClick={(e) => {
                                                e.stopPropagation();
                                                fnSelectedDataDelete(stateData[key]);
                                            }}
                                        />
                                    </Group>
                                </TD>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </ScrollArea>
    )
}

export default React.memo(StockCategorySubTable);